export const settings = {
  selector: '.js-contact-persons',
  filter: '.js-contact-persons-filter',
  activeFilter: '.js-contact-persons-filter.active',
  personCard: '.js-contact-person-card',
  showAllBtn: '.js-contact-persons-show-all',
  dropdown: '.js-contact-persons-filter-dropdown'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const filters = element.querySelectorAll( settings.filter )
  const dropdowns = element.querySelectorAll( settings.dropdown )
  Array.from( filters ).forEach(( filterEl ) => {
    initFilter( filterEl )
  })
  Array.from( dropdowns ).forEach(( dropdownEl ) => {
    initDropdown( dropdownEl )
  })
}

/**
 * Init filter.
 *
 * @param {DOMNode} filterEl
 */
const initFilter = ( filterEl ) => {
  filterEl.addEventListener( 'click', function() {
    const filters = document.querySelectorAll( settings.filter )
    const activeFilters = document.querySelectorAll( settings.activeFilter )
    const showAllClicked = this.dataset.value === 'all'

    // Remove active class from all the filter buttons if all are active
    if ( Array.from( filters ).length === Array.from( activeFilters ).length || showAllClicked ) {
      Array.from( filters ).forEach(( e ) => e.classList.remove( 'active' ))
    }

    toggleActiveClass( filterEl, activeFilters, showAllClicked )

    if ( showAllClicked ) {
      showAllContacts()
    } else {
      filterByLocation()
    }
  })
}

/**
 * Toggle filter active class.
 * @param {DOMNode} filter
 * @param {DOMNode} activeFilters
 * @param {boolean} showAllClicked
 */
const toggleActiveClass = ( filter, activeFilters, showAllClicked ) => {
  const showAllBtn = document.querySelector( settings.showAllBtn )
  const filterIsActive = filter.classList.contains( 'active' )
  const showAllIsActive = showAllBtn.classList.contains( 'active' )

    if ( filterIsActive && Array.from( activeFilters ).length > 1 ) {
      filter.classList.remove( 'active' )
    } else {
      filter.classList.add( 'active' )

      if ( showAllIsActive && !showAllClicked ) {
        showAllBtn.classList.remove( 'active' )
      }
    }
 }

/**
 * Filter persons.
 *
 */
const filterByLocation = () => {
  const dropdownSelected = document.querySelector( settings.dropdown )
  const activeFilters = document.querySelectorAll( settings.activeFilter )
  const allContacts = document.querySelectorAll( settings.personCard )
  const metropolitanArea = [ 'Helsinki', 'Espoo', 'Vantaa' ]

  const cities = Array.from( activeFilters ).map(( filter ) => filter.dataset.value )
  const metropolitanChosen = cities.includes( 'metropolitan' ) || dropdownSelected.value === 'metropolitan'
  const filters = metropolitanChosen ? cities.concat( metropolitanArea ) : cities

  // Hide or show contacts
  allContacts.forEach(( person ) => {
    const personLocations = JSON.parse( person.dataset.location )
    const personInArea = personLocations.some(( location ) => filters.includes( location )) || personLocations.includes( dropdownSelected.value )

    if ( !personInArea ) {
      person.classList.add( 'hidden' )
    } else {
      person.classList.remove( 'hidden' )
    }
  })
}

/**
 * Show all contacts.
 *
 */
const showAllContacts = () => {
  const allPeople = document.querySelectorAll( settings.personCard )
  allPeople.forEach(( person ) => {
      person.classList.remove( 'hidden' )
  })
}


/**
 * Init dropdown.
 *
 * @param {DOMNode} dropdownEl
 */
const initDropdown = ( dropdownEl ) => {
  dropdownEl.addEventListener( 'change', function() {
    const filters = document.querySelectorAll( settings.filter )
    const activeFilters = document.querySelectorAll( settings.activeFilter )
    const showAllClicked = this.value === 'all'

    // Remove active class from all the filter buttons if all are active
    if ( Array.from( filters ).length === Array.from( activeFilters ).length || showAllClicked ) {
      Array.from( filters ).forEach(( e ) => e.classList.remove( 'active' ))
    }

    if ( showAllClicked ) {
      showAllContacts()
    } else {
      filterByLocation()
    }
  })
}
